import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function InfoIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.8629 7.87963C12.8733 7.39691 12.4848 7 12.002 7C11.5194 7 11.131 7.39656 11.141 7.87907L11.2529 13.2536C11.2614 13.6603 11.5935 13.9855 12.0002 13.9855C12.4068 13.9855 12.7388 13.6606 12.7475 13.2541L12.8629 7.87963ZM11.2909 16.6908C11.4879 16.8969 11.7242 17 12 17C12.1818 17 12.347 16.9533 12.4955 16.8599C12.647 16.7633 12.7682 16.6345 12.8591 16.4734C12.953 16.3124 13 16.1337 13 15.9372C13 15.6473 12.9 15.3994 12.7 15.1932C12.503 14.9871 12.2697 14.8841 12 14.8841C11.7242 14.8841 11.4879 14.9871 11.2909 15.1932C11.097 15.3994 11 15.6473 11 15.9372C11 16.2335 11.097 16.4847 11.2909 16.6908Z"
        fill="currentColor"
      />
    </svg>
  )
}
